import { useEffect, useRef, useState } from 'react'
import { Dimensions, Platform, ScaledSize } from 'react-native'
import { isEmptyString } from '../strings'
export const sortObject = (o: any) => {
  return (
    Object.keys(o)
      .sort()
      // Todo: Check this again
      // eslint-disable-next-line no-sequences
      .reduce((r: any, k) => ((r[k] = o[k]), r), {})
  )
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'Unknown'.
 *
 * @returns {String}
 */
export const getMobileOperatingSystem = (): string => {
  var userAgent = navigator.userAgent || navigator.vendor

  if (/windows phone/i.test(userAgent)) {
    return 'Windows'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }

  return 'Unknown'
}

/**
 *Method to set value in localStorage
 * @param {string} key
 * @param {string} value
 * @returns{boolean}
 */
export const _storeData = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value)
    return true
  } catch (e) {
    console.error(e)
    return false
  }
}

export const isIE = () => {
  if (Platform.OS === 'android' || Platform.OS === 'ios') {
    return false
  }
  return /*@cc_on!@*/ false || !!document.documentMode
}

/**
 *Method to get value from localStorage
 * @param {string} key
 * @param {string} value
 * @returns{string}
 */

export const _retrieveData = (key: string) => {
  try {
    let value = window.localStorage.getItem(key)
    if (value && value !== null) {
      return value
    } else {
      return false
    }
  } catch (e) {
    console.error(e)
    return false
  }
}

/**
 * Method to remove the Local Storage
 * @param {Boolean} True/False
 */
export const _removeLocalStorage = (key: string) => {
  try {
    window.localStorage.removeItem(key)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

export const isEmptyObject = (obj: any) => {
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false
    }
  }
  return JSON.stringify(obj) === JSON.stringify({})
}

export function getAppOs() {
  const appVersion = navigator.appVersion
  const spItems = appVersion.split('(')
  const version = spItems[1]
  const [os] = version?.split(';')
  return os
}

export const ImageUrlDetection = (value: string) => {
  if (typeof value === 'string') {
    if (isEmptyString(value)) {
      //TODO: Fix this!
      return 'defaultPlaceHolder'
    }
    return value
  }
  return value
}

export const useIsLargeScreen = () => {
  const [dimensions, setDimensions] = useState(Dimensions.get('window'))
  useEffect(() => {
    const onDimensionsChange = ({ window }: { window: ScaledSize }) => {
      setDimensions(window)
    }
    const dimenListenr: any = Dimensions.addEventListener('change', onDimensionsChange)
    return () => dimenListenr.remove()
  }, [])
  if (Platform.OS !== 'web') {
    return false
  }
  return dimensions.width > 550
}

export const getDeviceType = () => {
  const ua = navigator.userAgent
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet'
  }
  if (
    /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
  ) {
    return 'MOB'
  }
  return 'desktop'
}

export const getLocation = () => {
  return new Promise((resolve, reject) => {
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    }
    navigator.geolocation?.getCurrentPosition(resolve, reject, options)
  })
}

export const isSessionLogout = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.error?.code === 'A50013' || apiHandlers[i]?.error?.code === 'U50013') {
      return true
    }
  }
  return false
}

export const getLoader = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.loading) {
      return apiHandlers[i]?.loading
    }
  }
  return false
}

export const getLoadingState = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.state === 'pending') {
      return true
    }
  }
  return false
}

export const getError = (apiHandlers: any): string | null => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.error) {
      return apiHandlers[i]?.error?.message
    }
  }

  return null
}

export const getErrorMessage = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.data?.message) {
      console.log('apiHandlers', apiHandlers[i]?.data?.message)
      return apiHandlers[i]?.data?.message
    } else if (apiHandlers[i]?.data?.data?.error?.message) {
      return apiHandlers[i]?.data?.data?.error?.message
    }
  }
  return false
}

export const getUserAck = (apiHandlers: any) => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.message) {
      return apiHandlers[i]?.message
    }
  }
  return null
}

export const isCardExpired = (month: number, year: number) => {
  const currentTime = new Date()
  const currentYear =
    String(year).length === 2 ? Number(currentTime.getFullYear().toString().substr(-2)) : currentTime.getFullYear()
  if (
    currentYear < year ||
    (currentYear === year && (currentTime.getMonth() + 1 === month || currentTime.getMonth() + 1 < month))
  ) {
    return false
  } else {
    return true
  }
}

export function hasKey<O>(obj: O, key: keyof any): key is keyof O {
  return key in obj
}

export const getMobNumExcludingCCode = (mobile: string): string => {
  if (mobile !== undefined) {
    if (mobile.length === 13 && mobile.startsWith('+91')) {
      return mobile.slice(3, 13)
    }
    if (mobile.length === 10) {
      return mobile
    }
  }
  return ''
}

export const compareArray = (first: Array<string | number> = [], second: Array<string | number> = []) => {
  return first.length === second.length && first.every((e) => second.includes(e))
}

export function useInterval(callback: unknown, delay: number | null): void {
  const savedCallback: any = useRef()
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    const tick = () => {
      savedCallback?.current()
    }
    if (delay !== null) {
      const timer = setInterval(tick, delay)
      return () => clearInterval(timer)
    }
    return undefined
  }, [delay])
}

export const wait = (time: number) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time)
  })
}
